import logToConsole from '@/utils/consoleHelper'

export default {
  AUTH_REQUESTED(state, username) {
    state.status = 'loading'
    logToConsole(
      'Attempting logging using username "' + username + '"',
      'debug'
    )
  },
  AUTH_SUCCESSFUL(
    state,
    { username, token, token_expires, refresh_token, refresh_token_expires }
  ) {
    state.status = 'success'
    state.username = username
    state.token = token
    state.token_expires = parseInt(token_expires) || false
    state.refresh_token = refresh_token
    state.refresh_token_expires = parseInt(refresh_token_expires) || false
    localStorage.setItem('username', username)
    localStorage.setItem('token', token)
    localStorage.setItem('token_expires', token_expires)
    localStorage.setItem('refresh_token', refresh_token)
    localStorage.setItem('refresh_token_expires', refresh_token_expires)
    logToConsole('Login successful for username "' + username + '"', 'debug')
  },
  AUTH_FAILURE(state, username) {
    state.status = 'failure'
    logToConsole('Login failure for username "' + username + '"', 'debug')
  },
  AUTH_RESET(state) {
    state.status = 'ready'
    state.token = false
    state.token_expires = false
    state.refresh_token = false
    state.refresh_token_expires = false
    state.username = false
    state.user_id = false
    localStorage.removeItem('token')
    localStorage.removeItem('token_expires')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('refresh_token_expires')
    localStorage.removeItem('username')
    localStorage.removeItem('user_id')
    logToConsole('Auth status successfully cleared', 'debug')
  },
  AUTH_LOGOUT_REQUESTED(state) {
    state.status = 'logging out'
    logToConsole('Authenticated user has requested to logout', 'debug')
  },
  AUTH_LOGOUT_SUCCESSFUL(state) {
    state.status = 'logged out'
    logToConsole('Authenticated user has successfully been logged out', 'debug')
  },
  AUTH_LOGOUT_FAILURE(state) {
    state.status = 'logout failure'
    logToConsole('Authenticated user has failed to log out', 'debug')
  },
  AUTH_PASSWORD_RESET_REQUESTED(state, email) {
    state.password_reset_status = 'loading'
    logToConsole(
      'Attempting password reset using email address "' + email + '"',
      'debug'
    )
  },
  AUTH_PASSWORD_RESET_SUCCESS(state, email) {
    state.password_reset_status = 'success'
    logToConsole(
      'Password reset successful for email address "' + email + '"',
      'debug'
    )
  },
  AUTH_PASSWORD_RESET_FAILURE(state, email) {
    state.password_reset_status = 'failure'
    logToConsole(
      'Password reset failure for email address "' + email + '"',
      'debug'
    )
  },
  AUTH_FORGOT_PASSWORD_REQUESTED(state, email) {
    state.forgot_password_status = 'loading'
    logToConsole(
      'Forgot password request sent using email address "' + email + '"',
      'debug'
    )
  },
  AUTH_FORGOT_PASSWORD_SUCCESS(state, email) {
    state.forgot_password_status = 'success'
    logToConsole(
      'Forgot password request completed for email address "' + email + '"',
      'debug'
    )
  },
  AUTH_FORGOT_PASSWORD_FAILURE(state, err) {
    state.forgot_password_status = 'failure'
    logToConsole(err, 'debug')
  },
  AUTH_STORE_USER_ID(state, user) {
    state.user_id = parseInt(user.id) || false
    localStorage.setItem('user_id', user.id)
    logToConsole('Storing authenticated user id [' + user.id + ']', 'debug')
  }
}
